export default __webpack_public_path__ + "static/media/computerLady5.264fa53d.jpg";